/**
* 工具方法
*/

// 部门对应颜色
function flrColorDep(type) {
	switch(type){
		case 'CT':
			return '#00CD6A';
			break;
		case 'DG':
			return '#5690FF';
			break;
		case 'DSA':
			return '#AC84FF';
			break;
		case 'ECT':
			return '#FFA100';
			break;
		case 'MRI':
			return '#FF6233';
			break;
		case 'US':
			return '#3F9EFF';
			break;
		case 'USCS':
			return '#00CE6A';
			break;
		case 'XRAY':
			return '#5690FF';
			break;
		default:
			return '#00CD6A'
			break;
	}
}

// 脱敏处理
function desensitize(str, type){
	if(type == 'mobile'){
		const mReg = /(\d{3})\d*(\d{4})/
		const _m = str.replace(mReg,'$1 **** $2')
		return _m
	}
}
/**
 * 默认返回yyyy-MM-dd HH-mm-ss
 * 可传第二个参数false，返回yyyy-MM-dd
 * 可传第三个参数，true 返回yyyy年MM月dd日
 * @param {*} str 
 */
function dateFormatter(str) {
  var hasTime = arguments[1] != false ? true : false;
  var hasType = arguments[2];
  var d = (typeof str === 'string' && str.indexOf('-') > 0) ? new Date(str.replace(/\-/g, '/')) : new Date(str)
  var year = d.getFullYear();
  var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
  var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
  var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
  var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
  if (hasTime) {
    if (hasType) {
      return `${year}年${month}月${day}日 ${hour}时${minute}分${second}秒`;
    }

    return [year, month, day].join('-') + " " + [hour, minute, second].join(':');

  } else {
    if (hasType) {
      return `${year}年${month}月${day}日`;
    }
    return [year, month, day].join('-');
  }
}

module.exports = {
	flrColorDep,
	desensitize,
	dateFormatter
}



//////////////////
// WEBPACK FOOTER
// ./packages/appletView/src/utils/util.js
// module id = n/qS
// module chunks = 1